import React from 'react';
import classNames from 'classnames';
import { BallotCheckIcon, CircleDollarIcon, CrownIcon } from '../../assets/icons';
import { BestValueCardProps } from './interfaces';
import styles from './BestValueCard.module.scss';

const defaultList = [
  {
    icon: <BallotCheckIcon />,
    text: (
      <p>
        <strong>Savings.</strong> $15 off each box (that's $60 saved a year!){' '}
      </p>
    ),
  },
  {
    icon: <CircleDollarIcon />,
    text: (
      <p>
        <strong>Max Choice. </strong> Early access to box customization to snag your faves
      </p>
    ),
  },
  {
    icon: <CrownIcon />,
    text: (
      <p>
        <strong>VIP Treatment. </strong> Exclusive access to our biggest sale events
      </p>
    ),
  },
];

const BestValueCard = ({
  children,
  plan,
  badge,
  className,
  perks = defaultList,
  alignment = 'center',
  size = 'normal',
  onClick,
}: BestValueCardProps) => {
  const wrapper = classNames(styles.wrapper, className, {
    [styles.wrapperCenter]: alignment === 'center',
    [styles.wrapperLeft]: alignment === 'left',
    [styles.wrapperLarge]: size === 'large',
  });
  return (
    <div
      className={wrapper}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {badge && (
        <div className={styles.wrapperBadge}>
          <span className={styles.badge}>{badge}</span>
        </div>
      )}
      {children ? (
        children
      ) : (
        <>
          <div className={styles.priceWrapper}>
            <div>{plan?.name}</div>
            <div className={styles.billingData}>
              <div>{plan?.price}</div>
              {plan?.billingInformation && (
                <p className={styles.billingInformation}>{plan?.billingInformation}</p>
              )}
            </div>
          </div>
          <ul className={styles.wrapperList}>
            {perks?.map((perk, index) => (
              <li key={`${index}-${perk.text}`}>
                <span>{perk.icon}</span>
                {perk.text}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default BestValueCard;
